<template>
  <div class="main-body">
    <div class="header">已通过实践站点</div>
    <div class="out">

      <div class="search2">
        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="float: right">
          <el-input placeholder="输入名称" v-model.number="name" clearable style="width:200px"></el-input>
          <el-button size="mini" style="margin-left:10px;" type="primary" icon="el-icon-search" @click="getList">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" :data="tableData" :height="th" border>


        <el-table-column prop="imgPath" label="图片">
          <template slot-scope="scope">
            <el-image :src="imgHost+scope.row.imgPath" style="width: 40px;height: 40px;"/>
          </template>
        </el-table-column>

        <el-table-column prop="name" label="名称"  fixed></el-table-column>

        <el-table-column prop="loginName" label="登录账号" ></el-table-column>
        <el-table-column prop="phone" label="手机号" ></el-table-column>
        <el-table-column prop="address" label="地址" ></el-table-column>

        <el-table-column prop="createTime" :formatter="getCreateTime" label="申请时间" ></el-table-column>

        <el-table-column prop="statsu" label="状态" >
          <template slot-scope="scope">
            <span v-if="scope.row.status == 1">正常</span>
            <span v-if="scope.row.status == 2">禁用</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" label="操作" width="250">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="success" size="mini" @click="handlePassword(scope.$index, scope.row)">修改密码
            </el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>


    <el-dialog title="密码修改" :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh'
               :close-on-click-modal='false'>
      <el-input v-model="password" placeholder="请输入登录密码" maxlength="10" minlength="6"
                show-password></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog=false">取 消</el-button>
        <el-button type="primary" @click="editPassword">提交</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>

import Add from "./Add";
import Edit from "./Edit";

import {timefilters, timeStr} from "@/common/times";
import {getStaffCode} from "@/utils/auth";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",
  data(){
    return{

      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,

      showModalAdd:false,
      showModalEdit:false,

      th:0,

      imgHost:this.$imgUrl,

      name:'',

      batchDialog: false,
      password:'',
      practiceSiteCode:'',

    }
  },
  created(){
    this.getList();
    this.th = this.$store.state.tableHeight;
  },
  components:{
    Add,Edit
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight' : function(val){
      this.th = val;
    },
  },
  methods:{

    handlePassword(index, rows) {
      this.batchDialog = true;
      this.practiceSiteCode = rows.practiceSiteCode
    },
    editPassword() {
      if (this.password.length < 6) {
        this.$message('密码至少为六位')
        return;
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'PracticeSite/EditPwd',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          practiceSiteCode: this.practiceSiteCode,
          password: this.password,
        }
      }).then((response) => {
        //console.log(response);
        if (response.data.error == 0) {
          this.$message('修改成功');
          this.batchDialog = false
        } else if (response.data.error == 1) {
          this.$message(response.data.message);
        } else {
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    getCreateTime(row) {
      return timefilters(row.createTime);
    },

    toggleModalAdd:function(){
      this.$refs.myAdd.init();
      this.showModalAdd = !this.showModalAdd;
    },
    closeAdd:function(){
      this.showModalAdd = !this.showModalAdd;
    },

    toggleModalEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit:function(){
      this.showModalEdit = !this.showModalEdit;
    },


    search(){
      this.currentPage = 1;
      this.getList();
    },

    getList(){
      this.$axios({
        method: 'post',
        url: this.$shopUrl+'PracticeSite/Page2',
        data: {
          timeStr:timeStr,
          sign:hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
          status:-1,
          name:this.name,
        }
      }).then( (response)=> {
        //console.log(response);
        if(response.data.error == 0){
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }else if(response.data.error == 1){
          this.$message(response.data.message);
        }else{
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getList();
    },

    changeStatus:function(selVal){
      this.status = selVal;
    },


    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },

    statusTitle(row){
      if(row.status == 0){
        return "默认";
      }
      if(row.status == 1){
        return "已通过";
      }
      if(row.status == 2){
        return "被禁用";
      }
      return "其它";
    },


  }
}
</script>

<style scoped>

</style>
